<template>
  <rect width="50" height="36" rx="3" fill="currentColor" />
  <rect y="38" width="10" height="10" rx="2" fill="currentColor" />
  <rect x="12" y="38" width="10" height="10" rx="2" fill="currentColor" />
  <rect x="24" y="38" width="10" height="10" rx="2" fill="currentColor" />
</template>
